import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ModalRegisterIndicator from "../modules/indicators/components/modals/RegisterIndicator";
import ModalSuccessRegisterIndicator from "../modules/indicators/components/modals/SuccessRegisterIndicator";
import ModalErrorRegisterIndicator from "../modules/indicators/components/modals/ErrorRegisterIndicator";
import "./Login.scss"
import { AuthContext } from "../common/components/auth/authContext/AuthContext";

function Login() {
  const { auth, login } = useContext(AuthContext)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const [errorProcessed, setErrorProcessed] = useState("");
  const [errorProcessedTime, setErrorProcessedTime] = useState(false);
  const returnTo = searchParams.get("returnTo") || "/";

  const [modalRegisterIndicator, setModalRegisterIndicator] = useState(false)
  const [modalSuccessRegisterIndicator, setModalSuccessRegisterIndicator] = useState(false)
  const [modalErrorRegisterIndicator, setModalErrorRegisterIndicator] = useState(false)
  const errorTimer = setTimeout(() => {
    sessionStorage.removeItem('auth_error');
    setErrorProcessedTime(false);
  }, 10000);

  // Verifica erros de autenticação armazenados no sessionStorage após um delay
  useEffect(() => {
    setErrorProcessed("");
    const storedError = sessionStorage.getItem('auth_error');

    if (storedError) {
      setErrorProcessedTime(true);
      setErrorProcessed(storedError);
      return () => clearTimeout(errorTimer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorProcessed]);

  useEffect(() => {
    if (auth) {
      navigate(returnTo, { replace: true })
    }
  }, [auth, navigate, returnTo])

  const handleCloseModal = (success) => {
    setModalRegisterIndicator(false);
    if (success != undefined && success) {
      setModalSuccessRegisterIndicator(true);
    }
    if (success != undefined && !success) {
      setModalErrorRegisterIndicator(true);
    }
  };
  const handleCloseModalSuccess = async () => {
    setModalSuccessRegisterIndicator(false)
  };
  const handleCloseModalError = async () => {
    setModalErrorRegisterIndicator(false)
  };

  return !auth && (
    <>
      <ModalRegisterIndicator
        open={modalRegisterIndicator}
        onClosed={handleCloseModal}
      />
      <ModalSuccessRegisterIndicator
        open={modalSuccessRegisterIndicator}
        onClosed={handleCloseModalSuccess}
      />
      <ModalErrorRegisterIndicator
        open={modalErrorRegisterIndicator}
        onClosed={handleCloseModalError}
      />
      <div className="login-page">
        <div className="header">
          <div className="p-2">
            {/* Linha 1: Escudo */}
            <div className="title ">
              <img className="login-img" src="/escudo_vermelho.png" alt="Logo" />
            </div>
            {/* Linha 2: Títulos sem padding */}
            <div className="title">
              <h2 className="login-loca ">loca</h2>
              <h2 className="login-vibe">vibe</h2>
              <h2 className="login-backoffice">backoffice</h2>
            </div>
          </div>

          <div className="p-2">
            {/* Linha 3: Botão "Entrar" */}
            <div className="login-button">
              <button onClick={() => login(returnTo)} className="button-text">
                Entrar
              </button>
            </div>
            {/* Linha 4: Botão "Cadastre-se como Embaixador" */}
            <div className="login-button">
              <a href="https://embaixador.locavibe.com.br/signup" target="_blank" rel="noopener noreferrer" className="button-text">
                Cadastre-se como <strong>Embaixador</strong>
              </a>
            </div>
            {errorProcessed && errorProcessedTime && (
              <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-black text-white shadow-lg rounded-lg px-6 py-3 animate-fade-in z-50 transition-opacity duration-300"><div className="flex items-center gap-3">
                <span className="text-xl">⚠️</span>
                <p className="text-sm font-medium">{errorProcessed}</p>
              </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
